<div class="space-x-3 bg-project-600 rounded-t-md text-project-2400">
  <h3
    class="mat-expansion-panel-header text-sm text-inherit h-[43px] flex items-center py-0 px-6"
  >
    {{ cardTitle }}
  </h3>
</div>
<div
  class="flex flex-col px-4 py-2 bg-white border divide-y rounded border-project-600 divide-project-600"
>
  <app-media-adder-item-condensed
    *ngIf="sectionImgsFormControl"
    [sectionFormControl]="sectionImgsFormControl"
    [mediaType]="MEDIA_TYPES.IMAGE"
    [cssIconClass]="'icon-image'"
    [addMediaLabel]="addMediaLabel"
    [isDisabled]="isDisabled"
    (handleAddMedia)="onAddMedia($event)"
    (handleRemoveMedia)="REMOVE_MEDIA_TYPE_HANDLERS[MEDIA_TYPES.IMAGE]($event)"
  >
    <ng-template let-media let-index="index">
      <div class="flex w-full pr-5 space-x-4">
        <div class="h-20 bg-project-600">
          <img
            class="object-contain h-full w-36"
            [src]="media.thumbnailUrl"
            [alt]="media.name"
            title="{{ media.name }}"
          />
        </div>
      </div>
    </ng-template>
  </app-media-adder-item-condensed>
</div>
